<template>
  <div class="contaier">
    <page-header></page-header>
    <div class="img-box img-box_error" :style="backgroundStyle">
      <!-- <img class="c-img" alt="hongqi" src="./../assets/img/ba1.jpg" /> -->
    </div>
    <div class="form-box">
      <div
        class="title xl:text-3xl md:text-2xl text-2xl md:pb-[30px] pb-[20px] font-semibold">
        {{ $t('home.title1') }}
      </div>
      <p class="note text-10px pb-[10px]" id="myElement">
        {{ $t('home.mandatory') }}
      </p>
      <el-form
        :model="form"
        ref="formRef"
        :rules="formRules"
        label-width="80px"
        label-position="top">
        <el-row :gutter="20">
          <el-col :md="4" :sm="6" :xs="8">
            <el-form-item :label="$t('home.appellation')" prop="title">
              <el-select
                style="width: 100%"
                :value="form.title"
                @change="changeTitle"
                :placeholder="$t('home.selectAppellation')">
                <el-option
                  :label="$t('appellation.Sir')"
                  :value="$t('appellation.Sir')"></el-option>
                <el-option
                  :label="$t('appellation.lady')"
                  :value="$t('appellation.lady')"></el-option>
                <el-option
                  :label="$t('appellation.Miss')"
                  :value="$t('appellation.Miss')"></el-option>
                <el-option
                  :label="$t('appellation.PhD')"
                  :value="$t('appellation.PhD')"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="10" :sm="18" :xs="16">
            <el-form-item :label="$t('home.lastName')" prop="lastName">
              <el-input
                v-model="form.lastName"
                :placeholder="$t('home.enterLastName')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="10" :sm="24">
            <el-form-item :label="$t('home.firstName')" prop="firstName">
              <el-input
                v-model="form.firstName"
                :placeholder="$t('home.enterFirstName')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('home.mobileNumber')" prop="phone">
              <div class="phone-box">
                <div class="phone-sum">+852</div>
                <div class="phone-">
                  <el-input
                    v-model="form.phone"
                    :placeholder="$t('home.enterPhone')"></el-input>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('home.emailAddress')" prop="email">
              <el-input
                v-model="form.email"
                :placeholder="$t('home.enterEmail')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('carOption.cartitle')" prop="carModel">
              <el-select
                value-key="id"
                style="width: 100%"
                :value="form.carModel"
                @change="changeCar"
                :no-data-text="$t('home.loading')"
                :placeholder="$t('carOption.carModel_')">
                <el-option
                  :value="item"
                  :key="item.id"
                  :label="item.car"
                  v-for="item in modelList"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('home.selectLanguage')" prop="language">
              <el-select
                style="width: 100%"
                :value="form.language"
                @change="changeLan"
                :placeholder="$t('home.pleaseSelectLanguage')">
                <el-option
                  :label="$t('home.lang_en')"
                  :value="$t('home.lang_en')"></el-option>
                <el-option
                  :label="$t('home.lang_cn')"
                  :value="$t('home.lang_cn')"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('home.remark')">
          <el-input
            type="textarea"
            show-word-limit
            maxlength="200"
            v-model="form.remark"
            :autosize="{ minRows: 1, maxRows: 16 }"></el-input>
        </el-form-item>

        <!-- <el-form-item prop="carReplace" :label="$t('home.plan')">
          <el-radio-group v-model="form.carReplace">
            <el-radio :label="true">{{ $t('home.yes') }}</el-radio>
            <el-radio :label="false">{{ $t('home.no') }}</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <el-form-item prop="agreePrivacy">
          <el-checkbox-group style="width: 100%" v-model="form.agreePrivacy">
            <el-checkbox name="agreePrivacy" :label="true">
              {{ $t('home.agree_') }}
              <a class="to-page" @click="goNewPage">{{ $t('home.policy_') }}</a>
              {{ $t('home.and')
              }}<a class="to-page" @click="goNewPage1">{{
                $t('home.statement_')
              }}</a>
              {{ $t('home.fullStop') }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>

        <el-form-item>
          <el-checkbox-group
            style="width: 100%"
            v-model="form.agreeUsePersonal">
            <el-checkbox name="agreeUsePersonal" :label="true">{{
              $t('home.privacyPolicy')
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <div class="btn" @click="submitForm">{{ this.showBtnText }}</div>
      </div>
    </div>
    <!-- <div @click="testFn1">testFn1</div> -->
    <!-- <div @click="testFn2">testFn2</div> -->
    <!-- <div @click="testFn3">testFn3</div> -->
    <footer-page></footer-page>
    <div class="dialog-box3_box">
      <el-dialog
        top="35vh"
        width="190px"
        :show-close="false"
        @close="closeDialogFn"
        :visible.sync="dialogVisible2">
        <div class="dialog-box dialog-box3" v-if="dialogSucceed">
          <i class="el-icon-check icon-check"></i>
          <div class="check-text">{{ $t('home.success') }}</div>
        </div>

        <div v-else class="dialog-box dialog-box2">
          <i class="el-icon-loading icon-check"></i>
        </div>
      </el-dialog>
    </div>
    <div class="dialog-box4_box">
      <el-dialog
        top="35vh"
        width="190px"
        :show-close="false"
        :visible.sync="dialogVisible3">
        <div class="dialog-box dialog-box4">
          <i class="el-icon-error icon-check"></i>
          <div class="check-text">{{ $t('home.exception') }}</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { imgBase } from '@/assets/js/static'
import { EventBus } from '@/assets/js/event-bus'
import { langMixins } from '@/mixins/langMixins'
import FooterPage from '@/components/FooterPage.vue'
import PageHeader from '@/components/PageHeader.vue'
import { modelListApi, addIcaurCusApi, payStripeCusApi } from '@/Api/requestApi'
export default {
  name: 'ContactUs',
  mixins: [langMixins],
  components: {
    PageHeader,
    FooterPage,
  },
  data() {
    let validateTitle = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.selectAppellation')))
      }
      callback()
    }
    let enterLastName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.enterLastName')))
      }
      callback()
    }
    let enterFirstName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.enterFirstName')))
      }
      callback()
    }
    let pleaseSelectLanguage = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.pleaseSelectLanguage')))
      }
      callback()
    }

    // let Postcode = (postcode) => {
    //   const regex = /^[0-9][0-9]{5}$/;
    //   return valid(postcode, regex, "請輸入正確的郵箱！");
    // };
    let Postcode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.enterEmail')))
      }
      const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!regExp.test(value)) {
        return callback(new Error(this.$t('home.rightEmail')))
      } else {
        callback()
      }
    }
    let phonecode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.enterPhone')))
      }
      const regExp = /^(4|5|6|7|8|9)\d{7}$/
      if (!regExp.test(value)) {
        return callback(new Error(this.$t('home.rightPhone')))
      } else {
        callback()
      }
    }

    let carModelCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('carOption.carModel_')))
      }
      callback()
      // const regExp = /^(4|5|6|8|9)\d{7}$/;
      // if (!regExp.test(value)) {
      //   return callback(new Error(this.$t("home.rightPhone")));
      // } else {
      //   callback();
      // }
    }

    // let corporateClient_ = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error(this.$t("home.corporateClient_")));
    //   }
    //   callback();
    // };

    let _policy = (rule, value, callback) => {
      if (!value.length) {
        return callback(new Error(this.$t('home._policy')))
      }
      callback()
    }

    return {
      isIos: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogSucceed: false,
      form: {
        title: '',
        lastName: '',
        firstName: '',
        phone: '',
        email: '',
        remark: '',
        language: this.$i18n.locale === 'zh' ? '繁體中文' : 'English',
        carModel: '',
        enterprise: '', //我加的
        enterpriseUser: '',
        carReplace: '',
        agreePrivacy: [],
        agreeUsePersonal: [],
        pay: 0,
      },
      modelList: [],
      formRules: {
        title: [
          { required: true, validator: validateTitle, trigger: 'change' },
        ],
        lastName: [
          { required: true, validator: enterLastName, trigger: 'blur' },
        ],
        firstName: [
          { required: true, validator: enterFirstName, trigger: 'blur' },
        ],
        language: [
          {
            required: true,
            validator: pleaseSelectLanguage,
            trigger: 'change',
          },
        ],
        phone: [{ required: true, validator: phonecode, trigger: 'change' }],
        email: [{ required: true, validator: Postcode, trigger: 'change' }],
        carModel: [
          { required: true, validator: carModelCode, trigger: 'change' },
        ],
        // enterprise: [{ required: true, validator: corporateClient_, trigger: "blur" }],

        agreePrivacy: [
          {
            type: 'array',
            // required: true,
            validator: _policy,
            trigger: 'change',
          },
        ],
      },
      car: '',
      imageUrl: require('@/assets/img/ba1.jpg'),
      // baImg: `backgroundImage: url(${this.ba})`,
    }
  },
  created() {
    EventBus.$on('message', this.receiveMessage)
  },
  beforeDestroy() {
    EventBus.$off('message', this.receiveMessage)
  },
  mounted() {
    const userAgent = navigator.userAgent
    if (/Mac|iPhone|iPod|iPad/.test(userAgent)) {
      this.isIos = true
    } else {
      this.isIos = false
    }

    this.modelListFn()
    this.$nextTick(() => {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0

      let { c, lang = 'zh', v } = this.$route?.query
      if (c) {
        this.car = c
      }
      if (v) {
        this.$router.push({
          path: '/contact/succeed',
          query: { lang: lang, v },
        })
      } else {
        this.langFn('/contact')
      }
    })
  },
  methods: {
    async payStripeCusFn(id, lang) {
      let { carModel } = this.form
      const {
        data: { code, data },
      } = await payStripeCusApi({
        lang,
        klmRegId: id,
        brand: 'hongqi',
        carModel: carModel,
      })

      if (code == 200) {
        this.form = {
          title: '',
          lastName: '',
          firstName: '',
          phone: '',
          email: '',
          remark: '',
          language: this.$i18n.locale === 'zh' ? '繁體中文' : 'English',
          carModel: '',
          enterpriseUser: '',
          carReplace: '',
          agreePrivacy: [],
          agreeUsePersonal: [],
          pay: 0,
        }
        this.$refs.formRef.resetFields()

        if (this.isIos) {
          window.location.href = data.url
        } else {
          window.open(data.url, '_blank')
        }
      } else {
        this.dialogVisible3 = true
      }
      this.dialogVisible2 = false
    },
    receiveMessage(msg) {
      console.log('msg :>> ', msg)
      this.changeLanguage(msg)
      // this.message = msg;
    },
    submitForm() {
      // this.dialogVisible2 = true;
      // let _lang = window.sessionStorage.getItem('sessionLang') || 'zh'
      // this.$router.push({ path: "/succeed", query: { lang: _lang } });
      // this.$router.push({ path: "/succeed" });
      // return;
      this.$refs.formRef.validate(async valid => {
        // console.log("valid :>> ", valid);
        if (valid) {
          let formDate_ = cloneDeep(this.form)

          formDate_.phone = `852 ${formDate_.phone}`

          // console.log("form :>>通过了 11", this.form);
          // return;

          formDate_.agreePrivacy = formDate_.agreePrivacy[0]
          formDate_.agreeUsePersonal = formDate_.agreeUsePersonal[0]
          delete formDate_.enterprise
          delete formDate_.pay
          // formDate_.agreePrivacy = formDate_.agreePrivacy.join("");
          // formDate_.agreeUsePersonal = formDate_.agreeUsePersonal.join("");

          console.log('form :>>通过了 ', formDate_)
          this.dialogVisible2 = true
          // return;
          const {
            data: { code, data },
          } = await addIcaurCusApi(formDate_)

          if (code === 200) {
            setTimeout(() => {
              // this.dialogSucceed = true
              let lang = 'zh'
              if (['English', '英文'].includes(formDate_.language)) {
                lang = 'en'
              }
              this.payStripeCusFn(data.id, lang)
            }, 1000)
          }
        } else {
          document.getElementById('myElement')?.scrollIntoView()
          return false
        }
      })
    },
    resetForm() {
      this.$refs.formRef.resetFields()
    },
    goNewPage() {
      let url_ = 'https://www.kamlung.com/privacy-policy?lang=tc'
      if (this.isIos) {
        window.location.href = url_
      } else {
        window.open(url_, '_blank')
      }
    },
    goNewPage1() {
      let url_ = 'https://www.kamlung.com/copy-of-privacy-policy?lang=tc'
      if (this.isIos) {
        window.location.href = url_
      } else {
        window.open(url_, '_blank')
      }
    },
    closeDialogFn() {
      this.dialogSucceed = false
    },
    openForm() {},
    changeLanguage(e) {
      // console.log("validateTitle :>> ", validateTitle);
      this.$refs.formRef.resetFields()
      if (e === 'en') {
        this.form.language = 'English'
      } else {
        console.log('e :>>2222 ', e)
        this.form.language = '繁體中文'
      }
    },
    async modelListFn() {
      const {
        data: { code, data },
      } = await modelListApi({ state: 1 })
      if (code == 200) {
        for (let i = 0; i < data.length; i++) {
          // imgKV
          const { id, pay, imgKV, modelName } = data[i]
          this.modelList.push({
            id,
            pay,
            car: modelName,
            imgKV: `${imgBase}${imgKV}`,
          })
        }
      }
    },
    changeTitle(v) {
      console.log('v :>>changeTitle ', v)
      this.form.title = v
    },
    changeCar(e) {
      console.log('v :>>changeTitle ', e)
      this.car = e.car
      this.form.pay = e.pay
      this.form.carModel = e.car
    },
    changeLan(v) {
      console.log('v :>>changeTitle ', v)
      this.form.language = v
    },
    testFn1() {
      this.dialogVisible2 = true
    },
    testFn2() {
      this.dialogVisible3 = true
    },
    testFn3() {
      this.dialogSucceed = true
    },
  },
  computed: {
    showBtnText() {
      let pay_ = this.form.pay
      if (this.$i18n.locale === 'zh') {
        if (pay_ > 0) {
          let num = new Intl.NumberFormat().format(pay_)
          return `立即支付 $${num}`
        } else {
          return '提交'
        }
      } else {
        if (pay_ > 0) {
          let num = new Intl.NumberFormat().format(pay_)
          return `Pay HK $${num}`
        } else {
          return 'Submit'
        }
      }
    },
    backgroundStyle() {
      let imgUrl = this.imageUrl
      if (this.car) {
        let car_ = this.modelList.find(e => e.car === this.car)
        if (car_ && car_?.imgKV) {
          imgUrl = car_.imgKV
        }
      }
      return {
        backgroundImage: `url(${imgUrl})`,
      }
    },
  },
}
</script>

<style lang="scss">
.row-expand-cover td .el-table__expand-icon {
  visibility: hidden;
}

input[aria-hidden='true'] {
  display: none !important;
}
.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: none !important;
}
</style>

<style lang="scss" scoped>
@import 'element-ui/lib/theme-chalk/display.css';

.el-form-item {
  margin-bottom: 26px !important;
}

.img-box {
  margin-top: 108px;
  width: 100%;
  height: 476px;
  // padding-top: 108px;
  // padding: 30px;
  // border-radius: 5px;
  // padding-bottom: 60px;
  // aspect-ratio: 16 / 4;
  // overflow: hidden;
  background-color: #f1f1f1;
  background-image: url('@/assets/img/ba1.jpg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  // background-size: auto 100%;
  // background-size: auto
  // .c-img {
  //   width: 100%;
  //   max-height: 500px;
  //   aspect-ratio: 17 / 7.5;
  //   object-fit: cover;
  // }
}
@media (max-width: 992px) {
  .img-box {
    aspect-ratio: 16 / 10;
    .c-img {
      object-fit: cover;
      aspect-ratio: 16 / 10;
    }
  }
}
@media (max-width: 768px) {
  .img-box {
    margin-top: 78px;
    aspect-ratio: 16 / 12;
    .c-img {
      aspect-ratio: 16 / 12;
    }
  }
}

.contaier {
  // padding-top: 110px;
  ::v-deep .el-dialog {
    border-radius: 10px !important;
    background: none !important;
    background-color: rgba(000, 000, 000, 0.6) !important;
  }
  .dialog-box4_box {
    ::v-deep .el-dialog {
      border-radius: 10px !important;
      background: none !important;
      background-color: rgba(255, 255, 255, 1) !important;
    }
    ::v-deep .el-dialog__body {
      padding: 10px 10px 30px 10px !important;
    }
  }
  .form-box {
    padding-top: 60px;
    // padding: 30px;
    // border-radius: 5px;
    padding-bottom: 60px;
    .title {
      font-family: 'icaurFontBold', sans-serif;
    }

    width: 92%;
    margin: 0 auto;
    max-width: 1000px;
    .phone-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .phone-sum {
        width: 66px;
        // padding-top: 10px;
        font-size: 1.1rem !important ;
        // line-height: 1.2rem !important;
        font-weight: 400;
      }
      .phone- {
        flex: 1;
      }
    }
    .note {
      color: #999;
    }
    .note:before {
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }
    ::v-deep .el-input {
      font-size: 1.05rem !important ;
    }
    ::v-deep .el-form-item__label {
      font-size: 1.15rem !important ;
      line-height: 1.6rem !important;
      font-weight: 400;
    }
    ::v-deep .el-radio__label {
      font-size: 1.15rem !important ;
      // line-height: 1.2rem !important;
      font-weight: 400;
    }
    ::v-deep .el-radio {
      // margin-right: 72px !important ;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-right: 30px !important;
    }

    ::v-deep .el-radio__inner {
      border-color: #000 !important ;
      transform: scale(1.5);
    }

    ::v-deep .el-radio-group {
      padding-left: 4px !important ;
    }

    ::v-deep .el-checkbox__inner {
      border-color: #000 !important ;
      // background-color: #000 !important ;
      transform: scale(1.5);
      // width: 22px !important;
      // height: 22px !important;
    }

    ::v-deep .el-checkbox__label {
      font-size: 1.05rem !important ;
      line-height: 1.6rem !important;
      padding-left: 15px !important;
      white-space: pre-wrap;
      color: #000;
      // line-height
      font-weight: 400;
    }

    ::v-deep .el-checkbox-group {
      padding-left: 4px !important;
    }
    ::v-deep .el-radio__input.is-checked + .el-radio__label {
      color: #000 !important;
    }
    ::v-deep .el-radio__input.is-checked .el-radio__inner {
      background: #000 !important ;
    }

    ::v-deep .is-checked .el-checkbox__inner {
      background-color: #000 !important ;
      // border-color: #409EFF;
    }

    .checkbox-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .checkbox- {
        width: 20px;
      }
      .text {
        padding-left: 10px;
        flex: 1;
        font-size: 1.1rem !important ;
        line-height: 1.8rem !important;
        font-weight: 400;
      }
    }
    .to-page {
      cursor: pointer;
      text-decoration: underline;
    }

    ::v-deep .el-input__inner {
      border: none !important;
      border-radius: 0 !important;
      border-bottom: #666 1px solid !important;
    }

    ::v-deep .el-textarea__inner {
      border: none !important;
      border-radius: 0 !important;
      border-bottom: #666 1px solid !important;
      resize: none;
      padding-right: 80px !important;
    }

    ::v-deep .is-error .el-input__inner {
      border-bottom: #f56c6c 2px solid !important;
    }
    .el-checkbox {
      display: flex !important;
      // justify-content: space-between;
      align-items: center;
    }
  }
  [aria-hidden='true'] {
    display: none !important;
  }
  ::v-deep.el-select-dropdown__item {
    font-size: 1.1rem !important ;
    // line-height: 1.2rem !important;
    font-weight: 400;
  }

  .btn-box {
    padding-top: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    .btn {
      // width: 200px;
      min-width: 140px;
      padding: 0 30px;
      line-height: 40px;
      border-radius: 20px;
      background-color: #000;
      cursor: pointer;
      color: #fff;
    }
  }
}

.dialog-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .icon-check {
    font-size: 60px;
    font-weight: 600;
    color: #fff;
  }
  .icon-check2 {
    font-size: 50px;
    font-weight: 600;
    color: #fff;
  }

  .title {
    padding-top: 10px;
    font-size: 16px;
    color: #fff;
  }
}

.dialog-box2 {
  padding-top: 20px;
  padding-bottom: 30px;
}
.dialog-box3 {
  padding-top: 5px;
  .check-text {
    font-size: 22px;
    padding-top: 10px;
    text-align: center;
    color: #fff;
  }
}

.dialog-box4 {
  // padding-top: 5px;
  .icon-check {
    font-size: 60px;
    font-weight: 600;
    // color: #333;
    color: #f56c6c;
  }
  .check-text {
    font-size: 15px;
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: center;
    color: #333;
    word-break: keep-all;
    // color: #f56c6c;
  }
}

.dialog-box3_box {
  ::v-deep .el-dialog__body {
    padding: 10px 20px 30px 20px !important;
  }
}
</style>
